import {MouseEventHandler, useCallback} from 'react';
import {ArrowButton} from '../ArrowButton/ArrowButton';
import {
  ArrowButtonDirection,
  ArrowButtonSize,
} from '../ArrowButton/ArrowButton.enum';

export function useRenderArrow({
  isMobile,
  hasArrow,
}: {
  isMobile: boolean;
  hasArrow: boolean;
}) {
  const renderNextArrow = useCallback(
    (goToNext: MouseEventHandler) => {
      if (isMobile || !hasArrow) {
        return null;
      }
      return (
        <ArrowButton
          direction={ArrowButtonDirection.Right}
          size={ArrowButtonSize.Large}
          onClick={goToNext}
          className="absolute top-1/2 -translate-y-1/2"
        />
      );
    },
    [isMobile, hasArrow]
  );

  const renderPrevArrow = useCallback(
    (goToPrev: MouseEventHandler) => {
      if (isMobile || !hasArrow) {
        return null;
      }
      return (
        <ArrowButton
          direction={ArrowButtonDirection.Left}
          size={ArrowButtonSize.Large}
          onClick={goToPrev}
          className="absolute top-1/2 -translate-y-1/2"
        />
      );
    },
    [isMobile, hasArrow]
  );

  return [renderNextArrow, renderPrevArrow];
}
